import React from "react";

// Customizable Area Start
import { styled, Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

import {
  Heading,
  MainContainer,
  WhiteContainer,
  GridContainer,
  BottomContainer,
  TextLabel,
} from "./GoldenPointCreate.web";

import { colors } from "../../../blocks/utilities/src/Colors";
import CustomLoader from "../../../components/src/customComponents/CustomLoader.web";
import { LoadingComponent as LoaderComponent } from "../../../components/src/Loader.web";
// Customizable Area End

import GoldenPointViewController, {
  // Customizable Area Start
  IGoldenPoint,
  // IPromotionOfferItem,
  // Customizable Area End
} from "./GoldenPointViewController.web";

// Customizable Area Start
import { renderBaseOnConditions } from "../../../blocks/utilities/src/CustomBlockHelpers";

const Strings = {
  pageTitle: "Golden Point",
  create: "Create",
  edit: "Edit",
  save: "Save",
  add: "Add",
  cancel: "Cancel",
  goldenPointSaved: "Golden point saved successfully",
  somethingWentWrong: "Something went wrong",

  // Form Labels
  goldenPointName: "Golden Point Name",
  goldenPointNameArabic: "Golden Point Name Arabic",
  goldenPointTextEn: "Golden Point Text (English)",
  goldenPointTextAr: "Golden Point Text (Arabic)",
  goldenPointReceiptText: "Golden Point Receipt Text",

  // Selection fields
  region: "Region",
  area: "Area",
  section: "Section",
  services: "Services",
  products: "Products",
  platform: "Platform",
  store: "Store",

  // Usage fields
  used: "Used",
  noOfOrders: "No. of Orders",
  startDate: "Start Date",
  endDate: "End Date",
  status: "Status",

  // Amount fields
  minAmount: "Minimum Order Amount",
  minItems: "Minimum Items",
  basePoint: "Base Points",
  bonusPoint: "Bonus Points",
  totalPoint: "Total Points",
  vatPoint: "Vat Points",
  finalPrice: "Final Price",
  price: "Price",
  tax: "Tax",

  startDateBase: "Start Date Base",
  endDateBase: "End Date Base",
  startDateBonus: "Start Date Bonus",
  endDateBonus: "End Date Bonus",
  expiryDaysBase: "Expiry Days Base",
  expiryDaysBonus: "Expiry Days Bonus",
  startDateFreewash: "Start Date Free Wash",
  endDateFreeWash: "End Date Free Wash",
  freeWashProduct: "Free Wash Product",
  freeWashProductQty: "Free Wash Product Quantity",
  freeWashProductDescription: "Free Wash Product Descriptiopn",

  availableTime: "Available Time",
  availableDay: "Available Day",
  excludedDates: "Excluded Dates",
  // General
  active: "Active",
  inactive: "Inactive",
  currency: "SAR",
  noViewDataString: "----",
  back: "Back",
  noData: "No Data",
  purchaseStartDate: "Purchase Start Date",
  purchaseEndDate: "Purchase End Date",
  mobileDescription: "Mobile Description",
  isRedeem: "Is Redeem",
};
// Customizable Area End

class GoldenPointView extends GoldenPointViewController {
  render() {
    // Customizable Area Start
    const { isLoading, noData, data, permissionStatus } = this.state;
    const {
      name,
      name_arabic,
      golden_point_text_en,
      golden_point_text_ar,
      receipt_text,
      base_points,
      bonus_points,
      total_points,
      vat_points,
      final_price,
      price,
      vat,
      free_wash_product,
      start_date_base,
      end_date_base,
      start_date_bonus,
      end_date_bonus,
      expiry_days_base,
      expiry_days_bonus,
      start_date_free_wash,
      end_date_free_wash,
      minimum_order_amount,
      exclude_days,
      categories,
      services,
      // free_wash_product,
      free_wash_quentity,
      is_redeem,
      free_wash_description,
      used,
      no_of_orders,
      minimum_items,
      status,
      platforms,
      regions,
      areas,
      store_management_ids,
      store_managements,
      excluded_dates,
      available_times,
      purchase_start_date,
      purchase_end_date,
      mobile_description,
      product_ids,
    } = data.attributes;

    // Customizable Area End

    return (
      // Customizable Area Start

      <>
        <CustomLoader loading={this.state.isViewLoading} />
        <MainContainer>
          <HeadingContainer>
            <Heading>{Strings.pageTitle}</Heading>

            <LoaderComponent
              isLoading={this.state.isLoadingPermission}
              height={44}
              width={160}
              disableParentWidth={true}
              isAllowed={permissionStatus.editPermission}
              children={
                <BottomContainer>
                  <button
                    data-test-id='btn-back'
                    onClick={() => this.redirectTo("GoldenPointList")}
                    className='cancel'
                    style={{ marginRight: 16 }}
                  >
                    {Strings.back}
                  </button>

                  <button
                    data-test-id='btn-edit'
                    onClick={() =>
                      this.redirectTo("GoldenPointEdit", {
                        id: this.props.navigation.getParam("id"),
                      })
                    }
                    className='add'
                  >
                    {Strings.edit}
                  </button>
                </BottomContainer>
              }
            />
          </HeadingContainer>

          {isLoading && !noData && <LoadingComponent />}

          {!isLoading &&
            noData &&
            (console.log("is Loading", { isLoading }),
            (<span style={{ color: "#EC4E20" }}>{Strings.noData}</span>))}
          {!isLoading && !noData && (
            <>
              <WhiteContainer>
                <GridContainer>
                  <div>
                    <TextLabel>{Strings.goldenPointName}</TextLabel>
                    <ValueText>{name || Strings.noViewDataString}</ValueText>
                  </div>
                  <div>
                    <TextLabel>{Strings.goldenPointNameArabic}</TextLabel>
                    <ValueText>
                      {name_arabic || Strings.noViewDataString}
                    </ValueText>
                  </div>

                  <div>
                    <TextLabel>{Strings.services}</TextLabel>
                    <ChipContainer>
                      {services && services.length > 0 ? (
                        services.map((name: string, index: number) => (
                          <StyledChip key={index}>{name}</StyledChip>
                        ))
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div>

                  <div>
                    <TextLabel>{Strings.goldenPointTextEn}</TextLabel>
                    <ValueText>
                      {golden_point_text_en || Strings.noViewDataString}
                    </ValueText>
                  </div>

                  <div>
                    <TextLabel>{Strings.goldenPointTextAr}</TextLabel>
                    <ValueText>
                      {golden_point_text_ar || Strings.noViewDataString}
                    </ValueText>
                  </div>
                  <div>
                    <TextLabel>{Strings.goldenPointReceiptText}</TextLabel>
                    <ValueText>
                      {receipt_text || Strings.noViewDataString}
                    </ValueText>
                  </div>
                  <div>
                    <TextLabel>{Strings.purchaseStartDate}</TextLabel>
                    <ValueText>
                      {purchase_start_date || Strings.noViewDataString}
                    </ValueText>
                  </div>
                  <div>
                    <TextLabel>{Strings.purchaseEndDate}</TextLabel>
                    <ValueText>
                      {purchase_end_date || Strings.noViewDataString}
                    </ValueText>
                  </div>
                  <div>
                    <TextLabel>{Strings.basePoint}</TextLabel>
                    <ValueText>
                      {base_points || Strings.noViewDataString}
                    </ValueText>
                  </div>
                  <div>
                    <TextLabel>{Strings.startDateBase}</TextLabel>
                    <ValueText>
                      {start_date_base || Strings.noViewDataString}
                    </ValueText>
                  </div>
                  <div>
                    <TextLabel>
                      {end_date_base
                        ? Strings.endDateBase
                        : Strings.expiryDaysBase}
                    </TextLabel>
                    <ValueText>
                      {end_date_base
                        ? end_date_base
                        : expiry_days_base || expiry_days_base === 0
                        ? expiry_days_base
                        : Strings.noViewDataString}
                    </ValueText>
                  </div>

                  <div>
                    <TextLabel>{Strings.bonusPoint}</TextLabel>
                    <ValueText>
                      {bonus_points || Strings.noViewDataString}
                    </ValueText>
                  </div>
                  <div>
                    <TextLabel>{Strings.startDateBonus}</TextLabel>
                    <ValueText>
                      {start_date_bonus || Strings.noViewDataString}
                    </ValueText>
                  </div>
                  <div>
                    <TextLabel>
                      {end_date_bonus
                        ? Strings.endDateBonus
                        : Strings.expiryDaysBonus}
                    </TextLabel>
                    <ValueText>
                      {end_date_bonus
                        ? end_date_bonus
                        : expiry_days_bonus || expiry_days_bonus === 0
                        ? expiry_days_bonus
                        : Strings.noViewDataString}
                    </ValueText>
                  </div>

                  <div>
                    <TextLabel>{Strings.totalPoint}</TextLabel>
                    <ValueText>
                      {total_points || Strings.noViewDataString}
                    </ValueText>
                  </div>
                  {/* <div>
                    <TextLabel>{Strings.vatPoint}</TextLabel>
                    <ValueText>
                      {vat_points || Strings.noViewDataString}
                    </ValueText>
                  </div> */}
                  <div>
                    <TextLabel>{Strings.price}</TextLabel>
                    <ValueText>{price || Strings.noViewDataString}</ValueText>
                  </div>

                  <div>
                    <TextLabel>{Strings.finalPrice}</TextLabel>
                    <ValueText>
                      {final_price || Strings.noViewDataString}
                    </ValueText>
                  </div>

                  <div>
                    <TextLabel>{Strings.tax}</TextLabel>
                    <ValueText>{vat || Strings.noViewDataString}</ValueText>
                  </div>

                  <div>
                    <TextLabel>{Strings.used}</TextLabel>
                    <ValueText>{used || Strings.noViewDataString}</ValueText>
                  </div>

                  {used === "specific_number_of_orders" && (
                    <div>
                      <TextLabel>{Strings.noOfOrders}</TextLabel>
                      <ValueText>
                        {no_of_orders || Strings.noViewDataString}
                      </ValueText>
                    </div>
                  )}
                  <div>
                    <TextLabel>{Strings.status}</TextLabel>
                    <ValueText>
                      {status === true
                        ? Strings.active
                        : status === false
                        ? Strings.inactive
                        : "-"}{" "}
                      {/* fallback if status is undefined/null/any other value */}
                    </ValueText>
                  </div>

                  <div>
                    <TextLabel>{Strings.region}</TextLabel>
                    <ChipContainer>
                      {regions && regions.length > 0 ? (
                        regions.map((name: string, index: number) => (
                          <StyledChip key={index}>{name}</StyledChip>
                        ))
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div>

                  <div>
                    <TextLabel>{Strings.area}</TextLabel>
                    <ChipContainer>
                      {areas && areas.length > 0 ? (
                        areas.map((name: string, index: number) => (
                          <StyledChip key={index}>{name}</StyledChip>
                        ))
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div>

                  <div>
                    <TextLabel>{Strings.section}</TextLabel>
                    <ChipContainer>
                      {categories && categories.length > 0 ? (
                        categories.map((name: string, index: number) => (
                          <StyledChip key={index}>{name}</StyledChip>
                        ))
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div>

                  <div>
                    <TextLabel>{Strings.services}</TextLabel>
                    <ChipContainer>
                      {services && services.length > 0 ? (
                        services.map((name: string, index: number) => (
                          <StyledChip key={index}>{name}</StyledChip>
                        ))
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div>
                  <div>
                    <TextLabel>{Strings.products}</TextLabel>
                    <ChipContainer>
                      {product_ids && product_ids.length > 0 ? (
                        product_ids.map((name: string, index: number) => (
                          <StyledChip key={index}>{name}</StyledChip>
                        ))
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div>

                  <div>
                    <TextLabel>{Strings.platform}</TextLabel>
                    <ChipContainer>
                      {platforms && platforms.length > 0 ? (
                        platforms.map((name: string, index: number) => (
                          <StyledChip key={index}>{name}</StyledChip>
                        ))
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div>

                  <div>
                    <TextLabel>{Strings.mobileDescription}</TextLabel>
                    <ValueText>
                      {mobile_description || Strings.noViewDataString}
                    </ValueText>
                  </div>
                  <div>
                    <TextLabel>{Strings.store}</TextLabel>
                    <ChipContainer>
                      {store_managements && store_managements.length > 0 ? (
                        store_managements.map(
                          (store_name: string, index: number) => (
                            <StyledChip key={index}>{store_name}</StyledChip>
                          )
                        )
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div>
                  <div>
                    <TextLabel>{Strings.isRedeem}</TextLabel>
                    <ValueText>
                      {is_redeem === true
                        ? "Yes"
                        : is_redeem === false
                        ? "No"
                        : Strings.noViewDataString}
                    </ValueText>
                  </div>
                  {/* <div>
                    <TextLabel>{Strings.freeWashProduct}</TextLabel>
                    <ChipContainer>
                      {free_wash_product && free_wash_product.length > 0 ? (
                        free_wash_product.map((name: string, index: number) => (
                          <StyledChip key={index}>{name}</StyledChip>
                        ))
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div> */}
                  <div>
                    <TextLabel>{Strings.freeWashProduct}</TextLabel>
                    {free_wash_product?.map((item: any, index: number) => (
                      <ItemBox key={index}>
                        <ItemText>Type: {item.item_type}</ItemText>
                        <ItemText>Product: {item.product_name}</ItemText>
                        {item.item_type === "parent_product" && (
                          <ItemText>
                            Applicable Products:{" "}
                            {item.applicable_products_count}
                          </ItemText>
                        )}
                      </ItemBox>
                    ))}
                  </div>
                  <div>
                    <TextLabel>{Strings.freeWashProductQty}</TextLabel>
                    <ValueText>
                      {free_wash_quentity || Strings.noViewDataString}
                    </ValueText>
                  </div>
                  <div>
                    <TextLabel>{Strings.startDateFreewash}</TextLabel>
                    <ValueText>
                      {start_date_free_wash || Strings.noViewDataString}
                    </ValueText>
                  </div>
                  <div>
                    <TextLabel>{Strings.endDateFreeWash}</TextLabel>
                    <ValueText>
                      {end_date_free_wash || Strings.noViewDataString}
                    </ValueText>
                  </div>
                  <div>
                    <TextLabel>{Strings.freeWashProductDescription}</TextLabel>
                    <ValueText>
                      {free_wash_description || Strings.noViewDataString}
                    </ValueText>
                  </div>
                  <div>
                    <TextLabel>{Strings.availableDay}</TextLabel>
                    <ChipContainer>
                      {exclude_days && exclude_days.length > 0 ? (
                        exclude_days.map(
                          (
                            item: string | { id: number; day: string },
                            index: number
                          ) => {
                            const text =
                              typeof item === "string" ? item : item.day;
                            const key =
                              typeof item === "string" ? index : item.id;
                            return <StyledChip key={key}>{text}</StyledChip>;
                          }
                        )
                      ) : (
                        <ValueText>{Strings.noViewDataString}</ValueText>
                      )}
                    </ChipContainer>
                  </div>
                </GridContainer>
                {available_times && available_times.length > 0 && (
                  <>
                    <Spacer32 />
                    <TextLabel>{Strings.availableTime}</TextLabel>
                    <ItemsContainer>
                      {available_times.map((item: any, index: number) => (
                        <ItemBox key={index}>
                          <ItemText>
                            Time Range:{" "}
                            {item.display_range ||
                              `${item.start_time} - ${item.end_time}`}
                          </ItemText>
                        </ItemBox>
                      ))}
                    </ItemsContainer>
                  </>
                )}
              </WhiteContainer>
            </>
          )}
        </MainContainer>
      </>
      // Customizable Area End
    );
  }
}

// Customizable Area Start
const HeadingContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "32px",
  flexWrap: "wrap",
});

const ValueText = styled("div")({
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 400,
  color: "#4D4D4D",
  marginTop: "8px",
});

const ChipContainer = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
  marginTop: "8px",
});

const StyledChip = styled("div")({
  padding: "4px 12px",
  backgroundColor: "#F1F5F9",
  borderRadius: "16px",
  fontSize: "14px",
  color: "#475569",
  border: "1px solid #E2E8F0",
});

const Spacer32 = styled("div")({
  height: "32px",
});

const LoadingComponent = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "200px",
  fontSize: 16,
  color: "#204B9C",
});

const ItemsContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  marginTop: "16px",
});

const ItemBox = styled("div")({
  padding: "16px",
  border: "1px solid #E2E8F0",
  borderRadius: "8px",
  backgroundColor: "#F8FAFC",
});

const ItemText = styled("div")({
  fontSize: "14px",
  lineHeight: "20px",
  color: "#475569",
  marginBottom: "4px",
  "&:last-child": {
    marginBottom: 0,
  },
});
// Customizable Area End

export default GoldenPointView;
